import { FC, useContext, useState } from 'react';
import { AppContext } from 'providers';
import { CbButton } from 'ui/components/Buttons/CbButton';
import { TableContext } from './';
import * as Sentry from '@sentry/browser';
import { useDisclosure } from '@chakra-ui/react';
import styles from './CbTable.module.css';
export const Export: FC = () => {
  const {
    setToast
  } = useContext(AppContext);
  const {
    exportModal: ExportModal,
    handleExport,
    hideExport
  } = useContext(TableContext);
  const [loading, setLoading] = useState<boolean>(false);
  const {
    isOpen: exportModalOpen,
    onClose: closeExportModal,
    onOpen: openExportModal
  } = useDisclosure();
  const onClick = ExportModal ? openExportModal : () => {
    setLoading(true);
    return handleExport().catch(e => {
      Sentry.captureException(e, {
        extra: {
          message: 'Unable to generate CSV export'
        }
      });
      setToast({
        description: 'Unable to generate export',
        status: 'error'
      });
    }).finally(() => setLoading(false));
  };
  if (hideExport === true) {
    return null;
  }
  return <>
      <CbButton isLoading={loading} onClick={onClick} size="sm" variant="outline" data-sentry-element="CbButton" data-sentry-source-file="Export.tsx">
        <span className={styles.buttonContent}>Export</span>
      </CbButton>
      {ExportModal && exportModalOpen && <ExportModal onClose={closeExportModal} />}
    </>;
};